import { BaseEnumEx } from './base-enum-ex'

// NOTE: Make sure this stays in sync with the server-side enum

export enum TimeUnit {
    Second = 0,
    Minute = 1,
    Hour = 2,
    Day = 3,
    Week = 4,
    Month = 5,
    Quarter = 6,
    Year = 7,
    TwoWeek = 8,
    OverMonth = 9,
}

export class TimeUnitEx extends BaseEnumEx {
    public static toDisplay(item: TimeUnit) {
        switch (item) {
            case TimeUnit.Second:
                return 'Second'
            case TimeUnit.Minute:
                return 'Minute'
            case TimeUnit.Hour:
                return 'Hour'
            case TimeUnit.Day:
                return 'Day'
            case TimeUnit.Week:
                return 'Week'
            case TimeUnit.Month:
                return 'Month'
            case TimeUnit.Quarter:
                return 'Quarter'
            case TimeUnit.Year:
                return 'Year'
            case TimeUnit.TwoWeek:
                return '2 Week'
            case TimeUnit.OverMonth:
                return '> Month'
        }
        return 'Unknown'
    }
    public static toDisplayPlural(item: TimeUnit) {
        switch (item) {
            case TimeUnit.Second:
                return 'Seconds'
            case TimeUnit.Minute:
                return 'Minutes'
            case TimeUnit.Hour:
                return 'Hours'
            case TimeUnit.Day:
                return 'Days'
            case TimeUnit.Week:
                return 'Weeks'
            case TimeUnit.Month:
                return 'Months'
            case TimeUnit.Quarter:
                return 'Quarters'
            case TimeUnit.Year:
                return 'Years'
            case TimeUnit.TwoWeek:
                return '2 Weeks'
            case TimeUnit.OverMonth:
                return '> Month'
        }
        return 'Unknown'
    }
    public static toDisplayWithUnit(item: TimeUnit) {
        switch (item) {
            case TimeUnit.Second:
                return '1 Second'
            case TimeUnit.Minute:
                return '1 Minute'
            case TimeUnit.Hour:
                return '1 Hour'
            case TimeUnit.Day:
                return '1 Day'
            case TimeUnit.Week:
                return '1 Week'
            case TimeUnit.Month:
                return '1 Month'
            case TimeUnit.Quarter:
                return '1 Quarter'
            case TimeUnit.Year:
                return '1 Year'
            case TimeUnit.TwoWeek:
                return '2 Weeks'
            case TimeUnit.OverMonth:
                return '> Month'
        }
        return 'Unknown'
    }

    public static toDisplayAdverb(item: TimeUnit) {
        switch (item) {
            case TimeUnit.Second:
                return 'Secondly'
            case TimeUnit.Minute:
                return 'Minutely'
            case TimeUnit.Hour:
                return 'Hourly'
            case TimeUnit.Day:
                return 'Daily'
            case TimeUnit.Week:
                return 'Weekly'
            case TimeUnit.Month:
                return 'Monthly'
            case TimeUnit.Quarter:
                return 'Quarterly'
            case TimeUnit.Year:
                return 'Yearly'
            case TimeUnit.TwoWeek:
                return 'Biweekly'
            case TimeUnit.OverMonth:
                return '> Monthly'
        }
        return 'Unknown'
    }
}
